<ng-container *transloco="let t; read: 'offer-config-ring-time-editor'">
  <form [formGroup]="form">
    <!--  Preset -->
    <div class="field mt-3">
      <p>
        <b>{{ t('presetButtonLabel') }}</b>
      </p>
      <p-selectButton
        id="presetValue"
        ariaLabel="{{ t('presetButtonLabel') }}"
        [formControl]="preset"
        [options]="possiblePresetValues"
        (onChange)="handlePresetChange($event.value)"
      >
        <ng-template let-item pTemplate="item">
          {{ t(item.label) }}
        </ng-template>
      </p-selectButton>
      <p-messages *ngIf="preset.value === presetValues.answerQuickly" severity="info">
        <ng-template pTemplate>
          <p class="wrap">{{ t('answerQuicklyDescription') }}</p>
        </ng-template>
      </p-messages>
    </div>
    <!-- Ring Time Seconds -->
    <div class="field mt-3">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="pi pi-arrow-down"></i></span>
        <span class="p-float-label">
          <p-inputNumber
            id="ringTimeoutSecondsLabel"
            mode="decimal"
            ariaLabel="{{ t('ringTimeoutSecondsLabel') }}"
            [formControl]="ringTimeoutSeconds"
            [max]="600"
            [min]="5"
            [ngClass]="{ 'ng-invalid': ringTimeoutSeconds?.invalid }"
            [showButtons]="true"
            suffix=" {{ t('ringTimeoutSecondsSuffix') }}"
            (onBlur)="handleTimeoutChange(ringTimeoutSeconds.value)"
            (onInput)="handleTimeoutChange(ringTimeoutSeconds.value)"
          >
          </p-inputNumber>
        </span>
      </div>
      <p-messages *ngIf="isShortRingTime" severity="warn">
        <ng-template pTemplate>
          <p class="wrap">{{ t('shortRingTimeWarningMessage') }}</p>
        </ng-template>
      </p-messages>
    </div>
    <!-- Hangup On VoiceMail -->
    <div class="field mt-3">
      <p-checkbox
        id="hangUpOnVoiceMail"
        ariaLabel="{{ t('hangUpOnVoiceMailLabel') }}"
        [binary]="true"
        [formControl]="hangUpOnVoiceMail"
        label="{{ t('hangUpOnVoiceMailLabel') }}"
        (onChange)="handleHangUpChange($event.checked)"
      >
      </p-checkbox>
      <span *ngIf="!hangUpOnVoiceMail.value" class="description" id="hangUpOnVoiceMailCheckedLabel-help">
        <p class="wrap">{{ t('hangUpOnVoiceMailCheckedLabel') }}</p>
      </span>
      <span *ngIf="hangUpOnVoiceMail.value" class="description" id="hangUpOnVoiceMailNotCheckedLabel-help">
        <p class="wrap">{{ t('hangUpOnVoiceMailNotCheckedHelpLabel') }}</p>
      </span>
    </div>
  </form>
</ng-container>
